import { ApiClient } from "client/base";
export class ChatToneClient extends ApiClient {
    createTone(create) {
        return this.base.post(`chat_tones`, create);
    }
    getTone(toneId) {
        return this.base.get(`chat_tones/${toneId}`);
    }
    getTones(filter) {
        const searchParams = new URLSearchParams("");
        for (const [key, value] of Object.entries(filter)) {
            searchParams.append(key, String(value));
        }
        return this.base.get(`chat_tones?${searchParams.toString()}`);
    }
    updateTone(toneId, update) {
        return this.base.patch(`chat_tones/${toneId}`, update);
    }
    deleteTone(toneId) {
        return this.base.delete(`chat_tones/${toneId}`);
    }
}
